
import { Step } from "@/lib/types";

export const setupAccountStep: Step = {
  id: "setup-account",
  type: "step",
  title: "Change TikTok account",
  description: "Before you start posting, we need to finish setting up the account.",
  todos: [
    {
      id: "profile-picture",
      text: "Add a profile picture",
      completed: false,
      hint: "Take an image here on Pinterest",
      hintLink: "https://www.pinterest.com/search/pins/?q=aesthetic couple&rs=typed"
    },
    {
      id: "bio",
      text: "Add a profile bio",
      completed: false,
      hint: "The bio should be:",
      hintCopy: "Questions to feel closer to your partner ✨\nSearch \"Cray Cray\" on the App Store"
    },
    {
      id: "account-name",
      text: "Change account name (not @)",
      completed: false,
      hint: "The account name should be:",
      hintCopy: "Couple Questions ✨"
    }
  ],
  buttonText: "Continue"
};
